module.exports = __webpack_public_path__ + "img/dne-exchange.c4bf2f0d.svg";